import React from "react";
import {
  HitsContainer,
  HitsBox,
  HitsDataBox,
  HitsHeading,
  HitsData,
  BackBtn,
} from "./StyledHits";
import { ScalingContainer } from "../../../AppStyled";

import { p40, p80 } from "./chances";
import useSound from "use-sound";
import goBack from "../../../audio/goBack.mp3";

export function HitsPage({
  volume,
  number,
  coeficients,
  unBlur,
  sound,
  display,
  toFix,
  handleAbove,
  bet,
  h,
  mode80,
}) {
  const [goBackSfx] = useSound(goBack, { volume });
  if (number) {
    let n = number.slice(4, number.lenght);
    let arr = coeficients.coefs[n];

    return (
      <HitsContainer
        className="HitsContainer"
        unBlur={unBlur}
        style={display ? { display: "flex" } : { display: "none" }}
      >
        <ScalingContainer className="ScalingContainer" h={h}>
          <div>
            <div>
              {arr.map((c, i) => {
                if (c === "0") {
                  return null;
                } else {
                  return (
                    <HitsBox key={i} className="HitsBox">
                      <HitsHeading className="HitsHeading">
                        <p className="TextRight">
                          {i} {((i === 0 || i === 1) && "Hit") || "Hits"}
                        </p>
                        <span> | </span>
                        <p className="TextLeft">{c}x</p>
                      </HitsHeading>
                      <HitsDataBox className="HitsDataBox">
                        <HitsData className="HitsData" right>
                          <h2>Profit</h2>
                          <p>{(bet * c - bet).toFixed(toFix)}</p>
                        </HitsData>
                        <HitsData className="HitsData">
                          <h2>Chance</h2>
                          <p>
                            {mode80
                              ? p80[n][i].toFixed(8)
                              : p40[n][i].toFixed(8)}
                          </p>
                        </HitsData>
                      </HitsDataBox>
                    </HitsBox>
                  );
                }
              })}
              <BackBtn
                onClick={() => {
                  if (sound) goBackSfx();
                  handleAbove(false);
                }}
              >
                back
              </BackBtn>
            </div>
          </div>
        </ScalingContainer>
      </HitsContainer>
    );
  } else {
    return null;
  }
}

export default HitsPage;
